import { defineMessages } from "react-intl";

export default defineMessages({
    documents: {
        id: "pages.documentPage.documents",
        defaultMessage: "Documents",
    },
});
